import { Send, Bell, Clock, CheckCircle, AlertCircle } from 'lucide-react';
import { useState } from 'react';

export default function NotificationCenter() {
  const [title, setTitle] = useState('');
  const [message, setMessage] = useState('');

  const handleSend = (e: React.FormEvent) => {
    e.preventDefault();
    if (confirm('Send this push notification to all users?')) {
      alert('Notification sent successfully!');
      setTitle('');
      setMessage('');
    }
  };

  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
      <div className="lg:col-span-2 space-y-6">
        <div>
          <h1 className="text-3xl font-bold text-white tracking-tight">Notification Center</h1>
          <p className="text-slate-400 mt-1">Send push notifications to mobile app users.</p>
        </div>

        <div className="bg-[#0B1623] border border-white/10 rounded-2xl p-6 md:p-8 shadow-xl">
          <form onSubmit={handleSend} className="space-y-6">
            <div>
              <label className="block text-sm font-medium text-slate-300 mb-2">Notification Title</label>
              <input 
                type="text" 
                required
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                className="w-full px-4 py-3 bg-black/20 border border-white/10 rounded-xl focus:outline-none focus:border-cyan-500 text-white placeholder:text-slate-600 transition-all"
                placeholder="e.g. Live Show Starting Now!"
              />
            </div>
            
            <div>
              <label className="block text-sm font-medium text-slate-300 mb-2">Message Content</label>
              <textarea 
                required
                rows={4}
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                className="w-full px-4 py-3 bg-black/20 border border-white/10 rounded-xl focus:outline-none focus:border-cyan-500 text-white placeholder:text-slate-600 transition-all resize-none"
                placeholder="e.g. Tune in to hear the latest hits with DJ Sarah..."
              />
              <p className="text-xs text-slate-500 mt-2 text-right">{message.length}/150 characters</p>
            </div>

            <div className="flex items-center justify-between pt-4 border-t border-white/5">
              <div className="flex items-center gap-2 text-sm text-amber-400 bg-amber-400/10 px-3 py-1.5 rounded-lg">
                <AlertCircle className="w-4 h-4" />
                <span>This will reach approx. 45k users</span>
              </div>
              <button 
                type="submit"
                className="flex items-center gap-2 bg-gradient-to-r from-cyan-600 to-blue-600 text-white px-6 py-3 rounded-xl hover:from-cyan-500 hover:to-blue-500 transition-all font-medium shadow-lg shadow-cyan-900/20"
              >
                <Send className="w-4 h-4" />
                Send Notification
              </button>
            </div>
          </form>
        </div>
      </div>

      <div className="space-y-6">
        <h2 className="text-xl font-bold text-white">Recent History</h2>
        <div className="space-y-4">
          {[
            { title: 'Live Show Alert', time: '2 hours ago', status: 'Sent' },
            { title: 'Weekend Schedule', time: '1 day ago', status: 'Sent' },
            { title: 'App Update Available', time: '3 days ago', status: 'Sent' },
          ].map((item, i) => (
            <div key={i} className="bg-[#0B1623] border border-white/10 rounded-xl p-4 hover:bg-white/[0.02] transition-all">
              <div className="flex justify-between items-start mb-2">
                <div className="p-2 bg-white/5 rounded-lg">
                  <Bell className="w-4 h-4 text-slate-300" />
                </div>
                <span className="text-xs font-medium text-green-400 bg-green-500/10 px-2 py-0.5 rounded border border-green-500/20 flex items-center gap-1">
                  <CheckCircle className="w-3 h-3" /> {item.status}
                </span>
              </div>
              <h3 className="font-medium text-white mb-1">{item.title}</h3>
              <div className="flex items-center gap-1.5 text-xs text-slate-500">
                <Clock className="w-3 h-3" />
                {item.time}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
